import { Enterprise } from 'models/Enterprises';
import { LOWEST_HIGHEST_COPY, SortingDirectionValues } from 'models/Sort';

export type EnterpriseTable = Pick<Enterprise, 'brandName'> &
  Record<
    | 'principal'
    | 'businessUnits'
    | 'employeesCount'
    | 'dealsCount'
    | 'managePeople'
    | 'editLink'
    | 'analyticsLink',
    string
  >;

export const TABLE_COLUMNS: Array<keyof EnterpriseTable> = [
  'brandName',
  'principal',
  'businessUnits',
  'employeesCount',
  'dealsCount',
  'managePeople',
  'editLink',
  'analyticsLink',
];

export const HEADING_TRANSLATIONS = {
  brandName: 'name',
  principal: 'principal',
  businessUnits: 'businessUnits',
  employeesCount: 'employees',
  dealsCount: 'deals',
  managePeople: '',
  editLink: '',
  analyticsLink: '',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  brandName: 'brandName',
  principal: 'principalEmail',
  businessUnits: 'numberOfBusinessUnits',
  employeesCount: 'numberOfEmployees',
  dealsCount: 'numberOfDeals',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  brandName: 200,
  principal: 200,
  businessUnits: 100,
  employeesCount: 100,
  dealsCount: 100,
};

export const NAME_FILTER_KEY = 'name';
export const PRINCIPAL_FILTER_KEY = 'principal';

export const MULTI_SORT_DIRECTION_COPY: Record<
  string,
  SortingDirectionValues[string]
> = {
  [SORTING_VALUES.businessUnits]: LOWEST_HIGHEST_COPY,
  [SORTING_VALUES.employeesCount]: LOWEST_HIGHEST_COPY,
  [SORTING_VALUES.dealsCount]: LOWEST_HIGHEST_COPY,
};

export const LOCKED_COLUMN: keyof EnterpriseTable = 'brandName';
